import { AsyncPropsMapper, BuilderConfig } from "../../../builder/types";
import { APICategoryProps } from "../../../interfaces/category-interface";
import { SHOP_DIRECTORY_API_HOST } from "../../../shared/constants";
import FullBleed, { Props } from "./full-bleed";

const mapper: AsyncPropsMapper<{ data: Array<APICategoryProps> }> = ({ data }) => {
    return {
        categorySlug: data.data.map((category: APICategoryProps) => ({
            name: category.attributes.name,
            value: category.attributes.slug,
        })),
    };
};

export const FullBleedConfig = {
    name: "Full Bleed",
    inputs: [
        {
            friendlyName: "Show on Index page",
            name: "showOnIndex",
            type: "boolean",
            defaultValue: false,
            required: true,
        },
        {
            friendlyName: "Show on Category page",
            name: "categorySlug",
            type: "dynamic-dropdown",
            required: false,
            options: {
                url: `${SHOP_DIRECTORY_API_HOST}/api/v1/categories?locale={{targeting.locale.0}}`,
                mapper: mapper.toString(),
            },
        },
        {
            name: "heading",
            type: "richText",
            required: true,
            defaultValue: "Main Heading",
        },
        {
            name: "body",
            type: "string",
            required: true,
            defaultValue: "Lorem Ipsum...",
        },
        {
            name: "backgroundImage",
            type: "file",
            allowedFileTypes: ["jpg", "jpeg", "png"],
            required: true,
        },
        {
            name: "logoImage",
            type: "file",
            allowedFileTypes: ["jpg", "jpeg", "png"],
            required: false,
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: FullBleed,
    config: FullBleedConfig,
};

export default builderConfig;
